export default "__VITE_ASSET__Bfz3lKny__"